<div class="container-loader-rbac">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>
